import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {map, switchMap, tap} from "rxjs/operators";
import {AuthServiceProvider, UserRole} from "src/app/services/col2/auth.service";
import {SchoolV3RestService} from "../../../services/rest/v3/school-rest.service";
import {V3School} from "../../../model/v3/schools";

@Component({
    selector: 'app-manager-menu',
    templateUrl: './manager-menu.component.html',
    styleUrls: ['./manager-menu.component.css'],
    standalone: false
})
export class ManagerMenuComponent implements OnInit {
  schoolId: string;
  school: V3School;
  private role: string

  constructor(
    private activeRoute: ActivatedRoute,
    private authService: AuthServiceProvider,
    private schoolV3Rest: SchoolV3RestService
  ) {}

  ngOnInit() {
    this.activeRoute.children[0].paramMap.pipe(
      tap(params => this.schoolId = params.get('schoolId')),
      switchMap(_ => this.schoolV3Rest.getSchool(Number(this.schoolId))),
      tap(school => this.school = school)
    ).subscribe();
    this.authService.get().pipe(
      switchMap(api => api.getUserRole()),
      tap(role => this.role = role)
    ).subscribe()
  }

  logout() {
    this.authService.get().subscribe(api=>api.logout());
  }

  getName() {
    // return ManagerUtils.getName();
  }

  getRole() {
    return this.role === UserRole.Manager? 'Role School Admin' : ''
  }


  logOutFromManager() {
    this.authService.get().subscribe((auth) => auth.logOutFromManager());
  }

  isAdminLoggedInAsManager() {
    return this.authService
      .get()
      .pipe(map((auth) => auth.isLoggedInAsManager()));
  }
}
